const qtTimeout = 10000

// 接口通过 qt 完成，然后传递到 js
/**
 * 1. jsToQt 告知 qt 交互类型
 * 2. qtToJs 获取 qt 返回
 * @param {String} action 事件类型
 * @param {Object} data 数据
 * @param {Boolean} needCallback 是否需要回调 默认不需要回调
 * @returns Promise 
 */
const getQtMsg = (action = '', data = {}, needCallback = false) => {
  console.log('发送请求----', action, JSON.stringify(data))
  return new Promise((resolve, reject) => {
    let flag = true
    if (needCallback) {
      setTimeout(() => {
        flag && reject({})
      }, qtTimeout)
      window.funQtWeb.qtToJs.connect(response => {
        console.log('qt 返回', response)
        flag = false
        response = typeof response === 'string' ? JSON.parse(response) : response
        if (response.action !== action) return
        if (Number(response.code) === 0) resolve(response)
        else reject(response)
      })
    }
    window.funQtWeb.jsToQt(JSON.stringify({
      action: action,
      ...data
    }))
  })
}

// 系统浏览器打开页面
export const openBrowser = url => {
  if (typeof window.qt !== 'undefined') {
    getQtMsg('open_browser', { url })
  } else {
    window.open(url, '__blank')
  }
}

// 账号登录
export const sendLogin = data => getQtMsg('web_login', { userInfo: JSON.stringify(data) }, true)

// 关闭最上层 webview
export const closeDialog = () => getQtMsg('close_top_dialog')

// 绑定账号
export const bindAccount = userInfo => getQtMsg('web_bind', { userInfo }, true)

// 解绑账号
export const unbindAccount = userInfo => getQtMsg('web_unbind', { userInfo }, true)

export default {
  openBrowser,
  sendLogin,
  closeDialog,
  unbindAccount
}
